import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  AVAILABILITY_CHECK_ERROR,
  DEFAULT_UNAVAILABILITY_CODE,
  OPERATIONS_OUTSIDE_BUSINESS_HOURS,
  PRICING_RANGES_NOT_UPDATED,
} from './operation-unavailability-codes';

export const titleProps = {
};

export const subtitleProps = {
  variant: 'medium_1',
  color: 'gray.A500',
  textAlign: 'center',
};
const buisinessHoursDialog = {
  title: 'Fuera de horario hábil',
  subtitle: (

    <Stack component="span" spacing={1.5} sx={{ width: '100%' }}>
      <Typography {...subtitleProps}>
        El ingreso de operaciones está habilitado de lunes a viernes, { ' ' }
        <Typography component="span" fontWeight="bold" color="inherit" variant="inherit">
          entre las 09:00 y 17:00 horas.{' '}
        </Typography>
      </Typography>
      <Typography {...subtitleProps}>
        Puedes avanzar para revisar tasas y costos mediante la simulación, pero el envío quedará
        disponible únicamente dentro de ese período.
      </Typography>
    </Stack>
  ),
};
const pricingRangesNotUpdatedDialog = {
  title: 'Tasas no actualizadas',
  subtitle: (
    <Stack component="span" spacing={1.5} sx={{ width: '100%' }}>
      <Typography {...subtitleProps}>
        Las tasas para hoy aun no se han actualizado, por lo que no es posible
        ceder tus facturas en este momento.
      </Typography>
      <Typography {...subtitleProps}>
        Puedes revisar la simulacion con la informacion del dia anterior. El
        envio de la operacion se habilitara en cuanto las condiciones se
        actualicen en breve.
      </Typography>
    </Stack>
  ),
};
const availabilityCheckErrorDialog = {
  title: 'No pudimos verificar la disponibilidad',
  subtitle: (
    <Stack component="span" spacing={1.5} sx={{ width: '100%' }}>
      <Typography {...subtitleProps}>
        Hubo un problema al comprobar si el servicio está disponible en este momento.
      </Typography>
      <Typography {...subtitleProps}>
        Puedes avanzar para revisar tasas y costos mediante la simulación, pero el envío
        quedará disponible cuando se pueda verificar la disponibilidad. Intenta nuevamente
        más tarde.
      </Typography>
    </Stack>
  ),
};
const defaultContent = {
  title: 'Operación no disponible',
  subtitle:
      'No es posible continuar con esta operación en este momento. Por favor, inténtalo más tarde.',
};
const blockDialogTitles = {
  [OPERATIONS_OUTSIDE_BUSINESS_HOURS]: buisinessHoursDialog,
  [PRICING_RANGES_NOT_UPDATED]: pricingRangesNotUpdatedDialog,
  [AVAILABILITY_CHECK_ERROR]: availabilityCheckErrorDialog,
  [DEFAULT_UNAVAILABILITY_CODE]: defaultContent,
};
export default blockDialogTitles;
